import React from "react";
import facebookIcon from "../../assets/facebook.svg";
import instagramIcon from "../../assets/instagram.svg";

function FooterIcons() {
    return (
        <div className="icons">
            <a href="https://www.facebook.com/etransport.lt" target="_blank" rel="noopener noreferrer">
                <img src={facebookIcon} alt="Facebook" className="social-icon" />
            </a>
            <a href="https://www.instagram.com/etransport1424" target="_blank" rel="noopener noreferrer">
                <img src={instagramIcon} alt="Instagram" className="social-icon" />
            </a>
        </div>
    );
}

export default FooterIcons;
